/**
 * @generated SignedSource<<b6d1741d98ae07d272de99a527f2a99f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductizedServiceMoreServices_productizedService$data = {
  readonly id: string;
  readonly userProfile: {
    readonly productizedServices: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"ProductizedServiceMoreCard_productizedService">;
        };
      }>;
    };
  };
  readonly " $fragmentType": "ProductizedServiceMoreServices_productizedService";
};
export type ProductizedServiceMoreServices_productizedService$key = {
  readonly " $data"?: ProductizedServiceMoreServices_productizedService$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductizedServiceMoreServices_productizedService">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductizedServiceMoreServices_productizedService",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProfile",
      "kind": "LinkedField",
      "name": "userProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserProfileProductizedServiceConnection",
          "kind": "LinkedField",
          "name": "productizedServices",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "UserProfileProductizedServiceEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProductizedService",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "ProductizedServiceMoreCard_productizedService"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProductizedService",
  "abstractKey": null
};
})();

(node as any).hash = "a0394eb3695365d74c7309ff2fa37434";

export default node;
